import React, { ReactElement } from 'react';
import { Paper, Typography, Box, useTheme } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import { ReadingsRequestDto } from '@thingslog/repositories';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';

export interface MobileQueryPreviewProps {
  payload: ReadingsRequestDto;
  fromDate: Date;
  toDate: Date;
  onClick: () => void;
}

export const MobileQueryPreview = ({
  payload,
  fromDate,
  toDate,
  onClick,
}: MobileQueryPreviewProps): ReactElement => {
  const { t } = useTranslation();
  const theme = useTheme();

  const getPreviewText = (): string => {
    const parts: string[] = [];
    if (payload.deviceGroupIds.length > 0) {
      parts.push(`${payload.deviceGroupIds.length} ${t('sensors_data_mobile_groups')}`);
    }
    if (payload.deviceSensorList.length > 0) {
      parts.push(`${payload.deviceSensorList.length} ${t('sensors_data_mobile_sensors')}`);
    }
    if (payload.deviceSensorTypeList.length > 0) {
      parts.push(`${payload.deviceSensorTypeList.length} ${t('sensors_data_mobile_types')}`);
    }

    if (parts.length === 0) {
      return t('sensors_data_mobile_no_filters_selected');
    }
    return parts.join(', ');
  };

  return (
    <Paper
      elevation={2}
      onClick={onClick}
      sx={{
        p: 2,
        mb: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer',
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.text.primary,
        borderRadius: 2,
      }}
    >
      <Box sx={{ flex: 1, mr: 2 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
          {getPreviewText()}
        </Typography>
        <Typography variant="caption" sx={{ opacity: 0.9, display: 'block' }}>
          {format(fromDate, 'dd/MM/yyyy HH:mm')} - {format(toDate, 'dd/MM/yyyy HH:mm')}
        </Typography>
      </Box>
      <InfoOutlined sx={{ color: 'inherit' }} />
    </Paper>
  );
};
